// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var SurveyBuilderMobilePreview$ReactHooksTemplate = require("./SurveyBuilderMobilePreview.res.js");

function SurveyBuilderSettingsShell(props) {
  return JsxRuntime.jsx("aside", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(SurveyBuilderMobilePreview$ReactHooksTemplate.make, {
                          children: props.preview
                        }),
                    className: "sb-right-preview sb-right-preview--only"
                  }),
              className: "sb-right"
            });
}

var make = SurveyBuilderSettingsShell;

exports.make = make;
/* react/jsx-runtime Not a pure module */
